import { useState, useEffect, useMemo } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Box, Grid } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import TabPanel from './TabPanel';
import { handleSnackBar, reRenderInfoBuilder, toggleRightDrawer, setFocusElement, setTabOnFocus, setDrawEvent, invokeGetService } from '../../store/global/actions';
import ListUserTriggers from '../molecules/user_triggers/ListUserTriggers';
import { useDispatch, useSelector } from 'react-redux';
import BreadCrumb from '../atoms/breadcrumb/';
import { marginBottomForBreadCrumb } from '../../config/styles';
import Divider from '@material-ui/core/Divider';
import CreateEvent from '../molecules/events/CreateEvent';
import MessageTree from '../molecules/messages/MessageTree';
import { getClusterlets } from '../../store/constructs/clusterlets/selectors';
import { getEvents } from '../../store/constructs/events/selectors';
import CodeEditor from '../molecules/events/CodeEditor';
import { getTabOnFocus, getCodeEditStatus, getRightDrawerStatus, getElementOnFocus, getLogRedirectionData } from '../../store/global/selectors';
import EditEvent from '../molecules/events/EditEvent';
import { getMessages } from '../../store/constructs/messages/selectors';
import { getUserTriggersOfSelectedEvent } from '../../store/constructs/user_triggers/selectors';
import { findRrdefsOfSelectedEvent } from '../../store/constructs/routing_rules/selectors';
import CreateField from '../molecules/fields/CreateField';
import EditField from '../molecules/fields/EditField';
import DeleteUserTriggerAlert from '../molecules/alerts/DeleteUserTriggerAlert';
import EditUserTrigger from '../molecules/user_triggers/EditUserTrigger';
import CreateUserTrigger from '../molecules/user_triggers/CreateUserTrigger';
import DeleteFieldAlert from '../molecules/alerts/DeleteFieldAlert';
import DeleteEventAlert from '../molecules/alerts/DeleteEventAlert';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteHandlerAlert from '../molecules/alerts/DeleteHandlerAlert';
import EditRoutingRule from '../molecules/routing_rules/EditRoutingRule';
import DeleteRoutingRuleAlert from '../molecules/alerts/DeleteRoutingRuleAlert';
import CreateRoutingRule from '../molecules/routing_rules/CreateRoutingRule';
import { makeStyles } from '@material-ui/core/styles';
import RenameEventType from '../molecules/messages/RenameEventType';
import { setReRender } from '../../store/global/actions';
import Alert from '@material-ui/lab/Alert/Alert';
import { invokePostService, setIsDocumentClicked } from '../../store/global/actions';
import AdvancedSetup from '../molecules/events/AdvancedSetup';
import { useBottomDrawer } from '../../hooks/useBottomDrawer';
import SkeletonLoader from '../atoms/loader/SkeletonLoader';
import CompactAlert from '../molecules/logs/LogRedirectionAlert';

const useStyles = makeStyles(() => ({
  fieldForm: {
    marginLeft: -12,
  },
  marginLeft: {
    marginLeft: 13,
  },
  tabButton: {
    marginLeft: 13,
    color: 'black',
    borderColor: '#1c548c',
  },
  activeTab: {
    marginLeft: 13,
    color: 'white',
    borderColor: '#1c548c',
    backgroundColor: '#1c548c',
    '&:hover': {
      backgroundColor: '#1c548c',
      color: 'white',
      borderColor: '#1c548c',
    },
  },
  tabMinWidth: {
    minWidth: 130,
  },
  alertMarginTop: {
    marginTop: 12,
  },
  handlerReuseAlert: {
    marginBottom: 10
  },
  tab: {
    '& .MuiTabs-root': {
      marginLeft: 0
    }
  },
  innerTabPanel: {
    '& .MuiBox-root': {
      padding: 0,
      paddingTop: '1rem'
    }
  },
  tablePanelWithNoPB: {
    root: {
      paddingBottom: 0
    },
    '& .MuiBox-root': {
      paddingBottom: '0',
      padding: '0 !important'
    }
  }
}));

export default function Event({ element, bottomDrawer, handleUpdateInDiagram }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const clusterlets = useSelector(getClusterlets);
  const events = useSelector(getEvents);
  const tabOnFocus = useSelector(getTabOnFocus);
  const userTriggers = useSelector(getUserTriggersOfSelectedEvent({ event: element.id }));
  const routingRules = useSelector(findRrdefsOfSelectedEvent({ event: element.id }));
  const elementOnFocus = useSelector(getElementOnFocus);
  const {activeTab: openTab, setActiveTab: setOpenTab, setTabConfig} = useBottomDrawer();

  const codeEditStatus = useSelector(getCodeEditStatus);
  const messages = useSelector(getMessages);
  const [breadCrumbItem, setBreadCrumbItem] = useState([]);
  const disableCreateRrdef = routingRules.length >= 1 ? true : false;
  const disableCreateUt = userTriggers.length >= 1 ? true : false;
  const [action, setAction] = useState({});
  const [msgReusedEvents, setMsgReusedEvents] = useState([]);
  const [showDeleteEventAlert, setShowDeleteEventAlert] = useState([true]);
  const [handlerReuseAlert, setHandlerReuseAlert] = useState("");
  const [handlerAssociatedEvent, setHandlerAssociatedEvent] = useState(undefined);
  const [isRrdefRequired, setIsRrdefRequired] = useState(null);
  const [hideCreateUserTriggerForEvent, setHideCreateUserTriggerForEvent] = useState(false);
  const [selectedEventRrdef, setSelectedEventRrdef] = useState(null);
  const [showDeleteRrdefAlert, setShowDeleteRrdefAlert] = useState(false);
  const [selectedEventUserTrigger, setSelectedEventUserTrigger] = useState(null);
  const [showDeleteUserTriggerAlert, setShowDeleteUserTriggerAlert] = useState(false);


  let detailsBC = [
    { label: 'Events', url: null },
    { label: element.name, url: null },
  ]

  const [eventFromDelegate, setEventFromDelegate] = useState(false);
  const [eventToDelegate, setEventToDelegate] = useState(false);
  const [onSendSuggestions, setOnSendSuggestions] = useState([])
  const [onRecvSuggestions, setOnRecvSuggestions] = useState([])
  const [srcDest, setSrcDest] = useState();
  const [checkmultiplerrDef, setcheckmultiplerrDef] = useState([])
  const [isDisableHandlerDeleteBtn, setIsDisableHandlerDeleteBtn] = useState(true);
  const [isTriggerEvent, setTriggerEvent] = useState(false)
  const [isLoading, setLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [disableCreateRrdefButton, setDisableCreateRrdefButton] = useState(false);
  const [itemToExpand, setItemToExpand] = useState(null);
  const [refreshTree, setRefreshTree] = useState(0);
  const logRedirectionData = useSelector(getLogRedirectionData)

  const isTemplate = element.category === 'template' ? true : false;


  // const userTriggerItem = [{ label: 'User Triggers', url: null }];

  // const rrdefItem = [{ label: 'Routing Rules', url: null }];

  // useEffect(() => {
  //   if (action.item?.name) {
  //     setBreadCrumbItem([{ label: action.item?.name, url: null }]);
  //   }
  // }, [action]);


  useEffect(() => {
    if (!eventFromDelegate && element?.item?.src) {
      dispatch(invokeGetService('getClusterletProperties', [element?.item?.src, false])).then((res) => {
        const tree = makeTree(res.data.allFields, res.data.sections)
        const suggestionList = makeSuggestionList(tree);
        setOnSendSuggestions([...suggestionList])
      })
    }
  }, [eventFromDelegate, element, action])

  useEffect(() => {

    if (!eventToDelegate && element?.item?.src) {
      dispatch(invokeGetService('getClusterletProperties', [element?.item?.dst, false])).then((res) => {
        const tree = makeTree(res.data.allFields, res.data.sections)
        const suggestionList = makeSuggestionList(tree);
        setOnRecvSuggestions([...suggestionList])
      })
    }
  }, [eventToDelegate, element])

  const makeTree = (fields, sections) => {
    let tree = []
    let fieldsInSection = fields.filter((item) => item.parent?.[0]?.type === 'section')
    fields = fields.filter(item => item.parent?.[0]?.type !== 'section')

    sections.forEach((section) => {
      const sectionChildren = fieldsInSection.filter(field => field.parent?.[0]?.id === section._id).map((field) => ({ id: field._id, name: field.name, type: field.attributes?.type, children: [] }))
      fieldsInSection = fieldsInSection.filter(field => field.parent?.[0]?.id !== section._id)
      tree.push({
        id: section._id,
        name: section.name,
        type: 'Struct',
        children: sectionChildren || []
      })
    })

    fields.forEach(field => {
      tree = traverseAndFindParent(field, tree)
    })

    return tree;
  }

  const makeSuggestionList = (tree, prefix = "instance") => {
    let list = [];

    tree.forEach((branch) => {
      list.push({
        label: `${prefix}.${branch.name} (${branch.type})`,
        kind: 'Variable',
        insertText: `${prefix}.${branch.name}`,
        documentation: `Type: ${branch.type}`,
        detail: `Type: ${branch.type}`
      })
      if (branch.children.length > 0) {
        list = [...list, ...makeSuggestionList(branch.children, `${prefix}.${branch.name}`)]
      }
    })

    return list
  }

  const traverseAndFindParent = (field, sections) => {
    sections?.forEach((section) => {
      if (field.parent?.[0]?.id === section.id) {
        section.children.push({ id: field._id, name: field.name, type: field?.attributes?.type, children: [] })
      } else {
        traverseAndFindParent(field, section.children)
      }
    })

    return sections;
  }

  useEffect(() => {
    setIsFetching(true);
    let promises = [
      dispatch(invokeGetService('getBlueprintConstructs', [])),
    ];
    if (element.protocol) {
      promises.push(dispatch(invokeGetService('getRrdefPlatformSchema', [element.protocol])))
    }
    Promise.all(promises).then(([response, routingRuleSchema]) => {
      if (response.status) {
        if (response.data.routingRules !== undefined) {
          let allRoutingRules = response.data.routingRules;
          let eventRrdef = allRoutingRules.find(item => item?.attributes?.tcmd === element?.id);
          setDisableCreateRrdefButton(eventRrdef !== undefined ? true : false);
         
          // Setting the event rrdef to open the rrdef edit form by default
          if(eventRrdef !== undefined && eventRrdef !== null){
            setSelectedEventRrdef(eventRrdef);
          }
         
          const event = response.data.events.find(item => item._id === element.id);
          const src = response.data.clusterlets.find(item => item._id === event.src);
          const dst = response.data.clusterlets.find(item => item._id === event.dst);
          const direction = src.type === 1 ? 'IN' : dst.type === 1 ? 'OUT' : null;
         
          if (routingRuleSchema?.status && routingRuleSchema?.data && routingRuleSchema?.data.length > 0 ) {
            const filteredRrdefSchema = routingRuleSchema.data.filter(template => {
              return template?.some(obj => obj?.name === "dir" && obj?.args?.default === direction);
            });
            if (filteredRrdefSchema.length > 0) {
              setIsRrdefRequired(true);
            } else {
              setIsRrdefRequired(false);
            }
          } else {
            setIsRrdefRequired(false);
          }
        } else {
          setIsRrdefRequired(false);
        }

        if(response.data.userTriggers != undefined){
          let allUserTriggers = response.data.userTriggers;
          let eventUserTrigger = allUserTriggers.find(item => item?.attributes?.op == element?.id);

          if(eventUserTrigger !== undefined && eventUserTrigger !== null){
            setSelectedEventUserTrigger(eventUserTrigger);
          }  
        }
      } else {
        console.error("Error while fetching constructs")
      }
      setIsFetching(false);
    }).catch(error => {
      console.error(error);
      setIsFetching(false);
    })
  }, [element, action?.action, hideCreateUserTriggerForEvent])

  useEffect(() => {

    if(tabOnFocus){
      setOpenTab(tabOnFocus);
    }

    setAction({});

    setBreadCrumbItem([]);
  }, [tabOnFocus]);


  const onCompletion = (event, action, gotoEventType = false, protocol) => {
    switch (action) {
      case 'edit':
        dispatch(handleSnackBar({ open: true, message: 'Event updated', severity: 'success' }));
        dispatch(setFocusElement({transaction: elementOnFocus?.transaction, id: event._id, type: 'event', item: event, name: event?.name, protocol: protocol, screen: "transaction" }));
        if (gotoEventType) dispatch(setTabOnFocus(1));
        break;

      case 'delete':
        dispatch(handleSnackBar({ open: true, message: 'Event deleted', severity: 'success' }));
        dispatch(setFocusElement({}));
        break;
      default:
        break;
    }
    
    dispatch(setReRender());
    dispatch(setDrawEvent(false));
    setAction({});
  };

  const onCancel = () => {
    dispatch(setDrawEvent(false));
    dispatch(toggleRightDrawer());
    dispatch(setReRender());
  };

  const event = events.find((e) => e.id === element.id);

  const isFromDelegate = clusterlets.find((c) => c._id === event?.src)?.type === 1;

  const isToDelegate = clusterlets.find((c) => c.id === event?.dst)?.type === 1;
  const isFromSensor = clusterlets.find((c) => c.id === event?.src)?.type === 4;
  const isToSensor = clusterlets.find((c) => c.id === event?.dst)?.type === 4;

  const selectedEventMessage = event?.message;

  const onHandlerCompletion = (action, handlerType) => {
    const type = handlerType === "onsend" ? "Onsend" : "Onreceive"
    dispatch(handleSnackBar({ open: true, message: `${type} handler definition updated`, severity: 'success' }));
  };


  const onHandlerClose = () => {
    dispatch(toggleRightDrawer());
  };

  const onActionCompletion = (type, action, errors, name, item) => {
    const rootElements = ['event', 'digitaltwin', 'delegate', 'analytics', 'sensor', 'transaction', 'Handler'];

    if (action !== undefined) {
      switch (action) {
        case 'add':
          dispatch(handleSnackBar({ open: true, message: `${type} created`, severity: 'success' }));

          if (type === "Field") {
            setItemToExpand(item?._id);
            setAction({ action: 'edit_field', id: item?._id.toString(), item: item })
            setRefreshTree(c => c + 1);
          } else if(type == "User trigger" && item != undefined){
            setSelectedEventUserTrigger(item)
          }
          else{
            setAction({});
          }
          break;

        case 'edit':
          dispatch(handleSnackBar({ open: true, message: `${type} updated`, severity: 'success' }));
          if (type !== 'Field' && type !== 'Property' && type !== 'Routing rule' && type !== 'User trigger') {
            dispatch(toggleRightDrawer());
          }

          // For handling the edit field form after update
          if (type === "Field") {
            setItemToExpand(item?._id);
            setAction({ action: 'edit_field', id: item?._id.toString(), item: item })
            setRefreshTree(c => c + 1);
          } else {
            setAction({});
          }
          break;

        case 'delete':
          dispatch(handleSnackBar({ open: true, message: `${type} deleted`, severity: 'success' }));

          if (type === "Field") {
            setRefreshTree(c => c + 1);
          }

          if (rootElements.includes(type)) {
            dispatch(setFocusElement(null));
          }
          setAction({});
          setShowDeleteRrdefAlert(false);
          setShowDeleteUserTriggerAlert(false);
          setDisableCreateRrdefButton(false);
          setSelectedEventRrdef(null);
          setSelectedEventUserTrigger(null);
          break;

        case 'clone':
          dispatch(handleSnackBar({ open: true, message: `${type} cloned`, severity: 'success' }));
          setAction({});
          break;
        default:
          break;
      }

      setBreadCrumbItem([]);

      if (type !== "Routing rule" && type !== "User trigger") {
        dispatch(reRenderInfoBuilder());
      }

    }
  };

  const onClose = () => {
    setAction({});
    setBreadCrumbItem([]);
    setShowDeleteRrdefAlert(false);
    setShowDeleteUserTriggerAlert(false);
  };

  const onChangeTab = (e, v) => {
    if (codeEditStatus) {
      dispatch(setIsDocumentClicked());
      return;
    }
    if (v === 2) {
      setLoading(true)
      dispatch(invokePostService('srcDest', { src: element?.item.src, dest: element?.item.dst })).then((res) => {
        setSrcDest(res?.result);
        setLoading(false)
      });
    } else if (v === 4) {
      setLoading(true)
      dispatch(invokePostService('isTriggerEvent', { src: element?.item.src })).then((res) => {
        setLoading(false)
        setTriggerEvent(res?.result);
      });

    }

    dispatch(setTabOnFocus(v));
    setOpenTab(v);
  };


  useMemo(() => {
    if (codeEditStatus) {
      dispatch(setIsDocumentClicked());
      return;
    }
    if(element?.item?.src && element?.item?.dst){
      if (openTab === 2) {
        setLoading(true)
        dispatch(invokePostService('srcDest', { src: element?.item?.src, dest: element?.item?.dst })).then((res) => {
          setSrcDest(res?.result);
          setLoading(false)
        });
      } else if (openTab === 4) {
        setLoading(true)
        dispatch(invokePostService('isTriggerEvent', { src: element?.item?.src })).then((res) => {
          setLoading(false)
          setTriggerEvent(res?.result);
        });
  
      }
    }

  },[openTab])

  useEffect(() => {
    if(element?.action){
      setAction(element.action)
    }
  },[element])

  useEffect(() => {
    setTabConfig([
      { label: "Event", tourId: "event-tab" },
      { label: "Event Type", tourId: "event-type-tab", isDisabled: element.id == null },
      { label: "Routing Rule", tourId: "routing-rules-tab", isDisabled: element.id == null },
      { label: "User Triggers", tourId: "user-trigger-tab", isDisabled: element.id == null },
      { label: "Onsend Handler", tourId: "onsend-handler-tab", isDisabled: element.id == null },
      { label: "Onreceive Handler", tourId: "onrecieve-handler-tab", isDisabled: element.id == null },
      { label: "Advanced", tourId: "advanced-tab", isDisabled: element.id == null }
    ])
  },[element])

  const handleDeleteRrdef = () => {
    setShowDeleteRrdefAlert(true);
  }

  const handleDeleteUserTrigger = () => {
    setShowDeleteUserTriggerAlert(true);
  }

  return (
    <>
      {
        !bottomDrawer &&
        <AppBar position="static">
          <Tabs value={openTab} onChange={ onChangeTab } >
            <Tab label="setup" data-ui-tour-id='event-tab' className={classes.tabMinWidth} />
            <Tab label="Event Type" data-ui-tour-id='event-type-tab' disabled={element.id == null} className={classes.tabMinWidth} />
            {/* <Tab label="Clusterlets" data-ui-tour-id='clusterlets-tab' disabled={element.id == null} className={classes.tabMinWidth} /> */}
            <Tab label="Routing Rule" data-ui-tour-id='routing-rules-tab' disabled={element.id == null} className={classes.tabMinWidth} />
            <Tab label="User Triggers" data-ui-tour-id='user-trigger-tab' disabled={element.id == null} />
            <Tab label="Onsend Handler" data-ui-tour-id='onsend-handler-tab' disabled={element.id == null || isFromDelegate || isFromSensor} className={classes.tabMinWidth} />
            <Tab label="Onreceive Handler" data-ui-tour-id='onrecieve-handler-tab' disabled={element.id == null || isToDelegate || isToSensor} className={classes.tabMinWidth} />
            <Tab label="Advanced" data-ui-tour-id='advanced-tab' className={classes.tabMinWidth} />
          </Tabs>
        </AppBar>
      }

      {/* Tab - Edit event */}
      <TabPanel value={openTab} index={!isTemplate ? 0 : undefined}>
      <Box style={{height: '5px'}} />
        {
          (logRedirectionData?.entity === "event" && logRedirectionData.entityId === element.id) && logRedirectionData.tabOnfocus !== 6 ?
            <CompactAlert severity={logRedirectionData?.level}>{logRedirectionData?.message}</CompactAlert>
          :
          null

        }
        {element.id == null && <CreateEvent onCompletion={onCompletion} onCancel={onCancel} element={element} />}

        {element.id !== null && element.id !== undefined && <EditEvent handleUpdateInDiagram={handleUpdateInDiagram} element={element} onCancel={onCancel} onCompletion={onCompletion} />}

        {action.action === 'delete_event' && showDeleteEventAlert && <DeleteEventAlert onCompletion={onCompletion} setShowDeleteEventAlert={setShowDeleteEventAlert} eventId={element.id} onClose={() => setAction({})} />}
      </TabPanel>

      {/* Tab - Event type */}
      <TabPanel value={openTab} index={1}>
      
        {
          <Grid container direction={'row'} spacing={2} className='verticalScrollBar'>


            {!element?.item?.message && <Grid item xs={12} style={{ height: '73vh' }}>
                <Alert severity="info">No event type configured.</Alert>              
            </Grid>}

            {element!= undefined && element.item != undefined && element.item.message != undefined && element.item.message != "" && <>
              <Grid item xs={6} style={{ height: '73vh' }}>
                <MessageTree parent={element} setAction={setAction} action={action} setMsgReusedEvents={setMsgReusedEvents} msgReusedEvents={msgReusedEvents} itemToExpand={itemToExpand} refreshTree={refreshTree} setRefreshTree={setRefreshTree}/>
              </Grid>

              {(Object.keys(action).length === 0 || action.action === 'rename_event_type') && (
                <Grid item xs={6} style={{ marginTop: 10 }} className='stickyContainer'>
                  {/* <RenameEventType message={(messages.find(item => item.id === selectedEventMessage)) ? (messages.find(item => item.id === selectedEventMessage)) : ""} /> */}
                  <RenameEventType event={element} />
                </Grid>
              )}
              {action.action === 'create_field' && (
                <Grid item xs={6} className={`${classes.fieldForm} stickyContainer`}>
                  <CreateField messageId={element?.item?.message} isEventType onClose={() => setAction({})} onCompletion={onActionCompletion} section={action} />
                </Grid>
              )}

              {action.action === 'edit_field' && (
                <Grid item xs={6} className={`${classes.fieldForm} stickyContainer`}>
                  <EditField messageId={element?.item?.message} isEventType key={action.id} onClose={() => setAction({})} onCompletion={onActionCompletion} fields={action} />
                </Grid>
              )}
            </>}
          </Grid>
        }

        {action.action === 'delete_field' && <DeleteFieldAlert messageId={element?.item?.message} onCompletion={onActionCompletion} id={action.id} onClose={() => setAction({})} />}
      </TabPanel>

      {/* Tab content - Clusterlets  */}
      {/* <TabPanel value={openTab} index={2}>
        <BreadCrumb items={[...detailsBC, { label: 'Source & Destination Details', url: null }]} />
        <Divider style={marginBottomForBreadCrumb} />

        <SrcDstTable element={element} />
      </TabPanel> */}

      {/* Tab content - Routing rules */}
      <TabPanel value={openTab} index={2}>
        {
          (logRedirectionData?.entity === "routing_rule" && logRedirectionData.entityId === selectedEventRrdef?._id) ?
            <CompactAlert severity={logRedirectionData?.level}>{logRedirectionData?.message}</CompactAlert>
          :
          null
        }
      <Box style={{height: '5px'}} />
      {isFetching || isLoading ? <Grid container direction={"row"} spacing={3}>
                <Grid item xs={12}>
                    <SkeletonLoader type="form" rows={9} />
                </Grid>
            </Grid>
          :
            srcDest === true ? (
              <Grid container direction={'row'} spacing={4} className={classes.alertMarginTop}>
                <Grid item xs={12}>
                  <Alert id="internalevent_rrdef_alert" severity="warning">The routing rules apply only to events going to or coming from a delegate!</Alert>
                </Grid>
              </Grid>
            ) : (
            <>

              <Grid container direction="row">
                {/* Create routing rule button */}
                {!disableCreateRrdefButton && isRrdefRequired && action?.action !== 'create_rrdef' && <>
                  <Grid item xs={12}  style={{ display: 'flex', justifyContent: 'flex-end' }}  >
                    <Tooltip title={disableCreateRrdef === true ? 'Routing rule exists' : 'Create routing rule'}>
                        <Button disabled={checkmultiplerrDef?.length >= 1} onClick={(e) => setAction({ action: 'create_rrdef' })} color="primary" variant="contained" style={{textTransform: 'capitalize', marginLeft: 10, marginBottom: 10 }} >
                          Create routing rule
                        </Button>
                    </Tooltip>
                  </Grid>
                  <Grid item xs={12}>
                      <Alert id="rrdef_alert" icon={false} severity="info">No routing rule exist </Alert>
                  </Grid>
                </>}

                

                {/* Delete routing rule button */}
                {isRrdefRequired && (selectedEventRrdef !== undefined && selectedEventRrdef !== null) && (
                  <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', cursor: 'pointer' }}>
                      <Tooltip title="Delete routing rule">
                        <DeleteIcon color="error" className={"delete_rrdef"} onClick={() => handleDeleteRrdef()} />
                    </Tooltip>
                  </Grid>
                )}
                
              </Grid>

              {/* Show not reuquired alert, if there is no rrdef in the schema */}
              {isRrdefRequired === false &&
              <Grid container direction={"row"} spacing={3} style={{marginBottom: 5}} >
                  <Grid item xs={12}>
                      <Alert id="rrdef_alert" icon={false} severity="info">No routing rule required</Alert>
                  </Grid>
              </Grid>}
              
              {/* {action.action !== 'create_rrdef' && action.action !== 'edit_rrdef' && <ListRoutingRules isRrdefRequired={isRrdefRequired} element={element} setAction={setAction} setcheckmultiplerrDef={setcheckmultiplerrDef} />} */}

              {action.action === 'create_rrdef' && <CreateRoutingRule element={element} onClose={onClose} onCompletion={onActionCompletion} />}
              {selectedEventRrdef !== undefined && selectedEventRrdef !== null && <EditRoutingRule element={element} rrdefId={selectedEventRrdef?._id} onClose={onClose} onCompletion={onActionCompletion} tag="event" hideCancel={true} />}
              {showDeleteRrdefAlert && <DeleteRoutingRuleAlert rrdefId={selectedEventRrdef?._id} onClose={onClose} onCompletion={onActionCompletion} />}
            </>
            )
      }
      </TabPanel>

      {/* Tab content - User triggers */}
      <TabPanel value={openTab} index={3}>
        
      <Box style={{height: '5px'}} />
        {
          isLoading ? (
            <Grid container style={{ height: '80vh' }}>
              <Grid item style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <p>Loading...</p>
              </Grid>
            </Grid>
          )
            : isTriggerEvent === true ? (
              <Grid container direction={'row'} spacing={4} className={classes.alertMarginTop}>
                <Grid item xs={12} id="user_trigger_alert">
                  <Alert severity="warning"> User triggers are applicable only to triggering events. </Alert>
                </Grid>
              </Grid>
            ) :
              <>

              <Grid container direction="row" style={{ marginBottom: '16px' }}>
                  {selectedEventUserTrigger != undefined && selectedEventUserTrigger != null && <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', cursor: 'pointer' }}>
                    <Tooltip title="Delete user trigger">
                      <DeleteIcon color="error" className={"delete_user_trigger"} onClick={() => handleDeleteUserTrigger()} />
                    </Tooltip>
                  </Grid>}
              </Grid>

                {/* {Object.keys(action).length === 0 && userTriggers.length === 0 && <NoUserTriggerAlert />}

              {Object.keys(action).length === 0 && userTriggers.length > 0 && <ListUserTriggers element={element} setAction={setAction} />} */}

                {/* {Object.keys(action).length === 0 && <NoUserTriggerAlert />} */}

                {/* {action.action !== 'create_user_trigger' && action.action !== 'edit_user_trigger' && action.action !== 'extend_fields' && <ListUserTriggers setHideUserTrigCreateBtn={setHideCreateUserTriggerForEvent} element={element} setAction={setAction} />} */}

                {/* {action.action === 'create_user_trigger' && <CreateUserTrigger element={element} onClose={onClose} onCompletion={onActionCompletion} />} */}
                {(selectedEventUserTrigger == undefined || selectedEventUserTrigger == null) && <CreateUserTrigger element={element} onClose={onClose} onCompletion={onActionCompletion} tag="event"/>}

                {/* {action.action === 'delete_user_trigger' && <DeleteUserTriggerAlert userTriggerId={selectedEventUserTrigger?._id} onClose={onClose} onCompletion={onActionCompletion} />} */}
                {showDeleteUserTriggerAlert && <DeleteUserTriggerAlert userTriggerId={selectedEventUserTrigger?._id} onClose={onClose} onCompletion={onActionCompletion} />}

                {/* {action.action === 'edit_user_trigger' && <EditUserTrigger userTriggerId={action.id} onClose={onClose} onCompletion={onActionCompletion} tag="event" />} */}
                {selectedEventUserTrigger != undefined && selectedEventUserTrigger != null && <EditUserTrigger userTriggerId={selectedEventUserTrigger?._id} onClose={onClose} onCompletion={onActionCompletion} tag="event" />}

                {/* {action.action === 'extend_fields' && <ExtendUTFields userTriggerId={action.id} onClose={onClose} onCompletion={onActionCompletion} />} */}
              </>
        }
      </TabPanel>

      {/* Tab content - onsend handler */}
      <TabPanel value={openTab} className={classes.tablePanelWithNoPB + " editor_tab_panel"} index={4} style={{paddingTop: 0}}>
        
      <Box style={{height: '5px'}} />
        {
          (logRedirectionData?.entity === "onsend_handler" && logRedirectionData.entityId === element.id)?
            <CompactAlert severity={logRedirectionData?.level} >{logRedirectionData?.message}</CompactAlert>
          :
          null

        }
        {eventFromDelegate && (
          <Grid container direction={'row'} spacing={4} className={classes.alertMarginTop}>
            <Grid item xs={12}>
              <Alert severity="warning" id="onsend_delegate_warning">
                <b>Onsend handler</b> is not applicable for events with delegate as source!
              </Alert>
            </Grid>
          </Grid>
        )}

        {!eventFromDelegate && (
          <>
              {handlerReuseAlert !== "" && (
                <Alert severity="warning" id="handlerReuseAlert" className={classes.handlerReuseAlert}>
                  {handlerReuseAlert}
                </Alert>
              )}
              <CodeEditor setAction={setAction} setIsDisableHandlerDeleteBtn={setIsDisableHandlerDeleteBtn} autoCompleteSuggestions={onSendSuggestions} setHandlerAssociatedEvent={setHandlerAssociatedEvent} setHandlerReuseAlert={setHandlerReuseAlert} setEventFromDelegate={setEventFromDelegate} element={element} handlerType={'onsend'} onCompletion={onHandlerCompletion} onCancel={onHandlerClose} />

              {action.action === 'delete_handler' && <DeleteHandlerAlert onCompletion={onActionCompletion} handlerType={'onsend'} category={element.category} id={element.id} onClose={() => setAction({})} element={element} handlerAssociatedEvent={handlerAssociatedEvent} />}
          </>
        )}
      </TabPanel>

      {/*Tab content - Onrecv handler  */}
      <TabPanel value={openTab} className={classes.tablePanelWithNoPB + " editor_tab_panel"} index={5}>
        
      <Box style={{height: '5px'}} />
        {
          (logRedirectionData?.entity === "onrecv_handler" && logRedirectionData.entityId === element.id)?
            <CompactAlert severity={logRedirectionData?.level}>{logRedirectionData?.message}</CompactAlert>
          :
          null

        }
        {eventToDelegate && (
          <Grid container direction={'row'} spacing={4} className={classes.alertMarginTop}>
            <Grid item xs={12}>
              <Alert severity="warning" id="onrecv_delegate_warning">
                <b>Onreceive handler</b> is not applicable for events with delegate as destination!
              </Alert>
            </Grid>
          </Grid>
        )}

        {!eventToDelegate && (
          <>
              {handlerReuseAlert !== "" && (
                <Alert severity="warning" id="handlerReuseAlert" className={classes.handlerReuseAlert} >
                  {handlerReuseAlert}
                </Alert>
              )}
              <CodeEditor setAction={setAction} setIsDisableHandlerDeleteBtn={setIsDisableHandlerDeleteBtn} autoCompleteSuggestions={onRecvSuggestions} setHandlerAssociatedEvent={setHandlerAssociatedEvent} setHandlerReuseAlert={setHandlerReuseAlert} setEventToDelegate={setEventToDelegate} element={element} handlerType={'onrecv'} onCompletion={onHandlerCompletion} onCancel={onHandlerClose} />

              {action.action === 'delete_handler' && <DeleteHandlerAlert onCompletion={onActionCompletion} handlerType={'onrecv'} category={element.category} id={element.id} onClose={() => setAction({})} element={element} handlerAssociatedEvent={handlerAssociatedEvent} />}
          </>
        )}
      </TabPanel>


      {/*Tab content - Advanced setup  */}
      <TabPanel value={openTab} className={classes.tablePanelWithNoPB} index={6}>
        {
          (logRedirectionData?.entity === "event" && logRedirectionData.entityId === element.id) && logRedirectionData.tabOnfocus === 6 ?
            <CompactAlert severity={logRedirectionData?.level}>{logRedirectionData?.message}</CompactAlert>
          :
          null

        }
      <Box style={{height: '5px'}} />
        <AdvancedSetup element={element} handleUpdateInDiagram={handleUpdateInDiagram} onCompletion={onCompletion} />
      </TabPanel>
    </>
  );
}
